import React from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';

interface AppBarNavProps {
  children: React.ReactNode;
  name?: string;
}

export const AppBarNav = ({ children, name }: AppBarNavProps) => (
  <StackLayout
    as="nav"
    aria-label={name}
    orientation="horizontal"
    verticalAlignment="stretch"
  >
    {children}
  </StackLayout>
);
